import {api} from "../../services";
import Swal from "sweetalert2";

const logs = {
    state: {
        pagination: [],
        log: {
          properties: {}
        }
    },
    getters: {},
    mutations: {
        SET_LOGS(state, payload) {
            state.pagination = payload
        },
        SET_LOG(state, payload) {
            state.log = payload
        },
    },
    actions: {
        getLogs(context, payload) {
            api.get('/logs', {
                params: payload
            }).then(response => {
                context.commit("SET_LOGS", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
    },
}
export default logs;
